const matchCase = (source, singular, plural) => {
    const replacement = source.toLowerCase().endsWith("s") ? plural : singular;

    if (source === source.toUpperCase()) return replacement.toUpperCase();
    if (source[0] === source[0].toUpperCase()) {
        return replacement[0].toUpperCase() + replacement.slice(1);
    }

    return replacement;
};

export const getClientServiceMessage = (message, fallback = "") => {
    const displayMessage = typeof message === "string" && message ? message : fallback;

    return displayMessage.replace(/\bsubscriptions?\b/gi, (match) =>
        matchCase(match, "service", "services"),
    );
};
